<template lang="html">
  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 v-if="campaign === false" class="h2">Nieuwe campagne</h4>
            <h4 v-else class="h2">Bewerk campagne</h4>
          </div>
          <div>
            <div style="margin-top:125px" v-if="isLoading" class="circle-loader"></div>
            <b-tabs style="margin-left: 20px" content-class="mt-3">
              <b-tab title="Status" active>
                <div style="margin: 20px">
                  <div class="message">
                    <div style="width:100%">
                      <h4 class="card-4 text-center">Campaign status</h4>
                    </div>

                    <div class='col-md-12 grid-margin'>
                      <div class='card'>
                        <div class='card-body'>
                          <div class='row'>
                            <div class='col-lg-4'>
                              <div class='d-flex'>
                                <div class='wrapper'>
                                  <h3 class='mb-0 font-weight-semibold'>{{contacts_called}}</h3>
                                  <h5 class='mb-0 font-weight-medium text-primary'>gebeld</h5>
                                </div>
                                <div class='wrapper col-lg-6'>
<!--                                  <stats-line-graph-1 :height="50" :width="100"></stats-line-graph-1>-->
                                </div>
                              </div>
                            </div>
                            <div class='col-lg-4'>
                              <div class='d-flex'>
                                <div class='wrapper'>
                                  <h3 class='mb-0 font-weight-semibold'>{{contacts_forwarded}}</h3>
                                  <h5 class='mb-0 font-weight-medium text-primary'>doorgeschakeld</h5>
                                </div>
                                <div class='wrapper col-lg-6'>
<!--                                  <stats-line-graph-1 :height="50" :width="100"></stats-line-graph-1>-->
                                </div>
                              </div>
                            </div>
                            <div class='col-lg-4'>
                              <div class='d-flex'>
                                <div class='wrapper'>
                                  <h3 class='mb-0 font-weight-semibold'>{{contacts_answering_machine}}</h3>
                                  <h5 class='mb-0 font-weight-medium text-primary'>antwoord apparaat </h5>
                                </div>
                                <div class='wrapper col-lg-6'>
<!--                                  <stats-line-graph-2 :height="50" :width="100"></stats-line-graph-2>-->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center" style="margin-top:25px">
                      <h2 class="text-center" v-bind:class="getActiveInactiveClass(this.isCampaignActive)">{{ resumePauseButtonText }} </h2>

                    </div>
                    <div class="static">
                      <div class="d-flex justify-content-around">

                        <b-button :disabled="campaignId === false" class="btn-rounded" style="background-color: white; text-align: center" @click="resumePauseButtonClick($event)">
                          <img  v-if="!isCampaignActive" style="height:120px; border: none" class="ml-0" src="../../assets/icons/noun_play_3535575.png">
                          <img v-if="isCampaignActive" style="height:120px; border: none" class="ml-0" src="../../assets/icons/noun_pause_3535549.png">
                        </b-button>
                        <div  v-bind:style="{ backgroundImage: 'url(../../src/assets/icons/noun_play_3535575.png)'}"></div>
                      </div>
                    </div>
<!--                    <div class="staticOnlineoffline">-->
<!--                      <div class="d-flex justify-content-center">-->

<!--                        <b-button :disabled="campaignId === false" class="btn-rounded" style="background-color: white; text-align: center" @click="resumePauseButtonClick($event)">-->
<!--                          <img  v-if="!isCampaignActive" style="height:120px; border: none" class="ml-0" src="../../assets/icons/noun_play_3535575.png">-->
<!--                          <img v-if="isCampaignActive" style="height:120px; border: none" class="ml-0" src="../../assets/icons/noun_pause_3535549.png">-->
<!--                        </b-button>-->
<!--                        <div  v-bind:style="{ backgroundImage: 'url(../../src/assets/icons/noun_play_3535575.png)'}"></div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="d-flex justify-content-center">
                      <p id="errorMessageCampaign" style="color: red; font-weight: bold"></p>
                    </div>
                    <div>
                      <div class="d-flex justify-content-center" style="margin-top:25px">
<!--                        <h4 style="margin-bottom:50px" class="h6" v-if="statusContactsDb.length === 0 || statusContactsDb === false">Er werden nog geen contacten geïmporteerd</h4>-->
                        <b-table v-if="statusContactsDb.length > 0" striped hover :items="statusContactsDb" :fields="statusContactsFields" style="max-width:65%; margin-bottom:50px;">
                          <template v-slot:cell(status)="{ value }">
                            <img v-if="value === 'todo'" src="../../assets/icons/todo.png">
                            <div style="width:20px; height: 20px; margin-left:12px" v-if="value === 'in_progress'" class="circle-loader"></div>
<!--                            <img v-if="value === 'in_progress'" src="../../assets/icons/in_progress.png">-->
                            <img v-if="value === 'done'" src="../../assets/icons/done.png">
                            <img v-if="value === 'error' || value === 'Mislukt'" src="../../assets/icons/error.png">
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Instellingen">
                <p v-if="errors.length">
                  <b class="text-danger">Fout tijdens het valideren van de ingegeven data:</b>
                </p>
                <ul>
                  <li v-bind:key="error" v-for="error in errors" class="text-danger">{{ error }}</li>
                </ul>
                <form v-if="!isLoading" style="margin: 20px;" action="#" @submit="updateCampaign($route.params.campaignId)">
                  <div class="form-group">
                    <label class="label">Naam</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="name" ref="name" placeholder="Naam" id="name">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="label">Beschrijving</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="description" ref="name" placeholder="Beschrijving" id="description">
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="label">Audio bestand (wordt afgespeeld wanneer contact opneemt)</label>
                    <div class="input-group col-xs-12">
                      <b-select v-model="selectedRedirectAudiofile" name="selectedRedirectAudiofile" id="selectedRedirectAudiofile" variant="outline-primary">
                        <b-select-option v-for="(audiofile) in audiofilesDb" :key="audiofile.audiofile_id" :value="audiofile.audiofile_id">{{audiofile.filename}}</b-select-option>
                      </b-select>
                    </div>
                  <div class="form-group" style="margin-top:10px">
                    <label class="label">Audio bestand - voicemail</label>
                    <b-select v-model="selectedVoicemailFile" name="selectedRedirectAudiofile" id="selectedRedirectAudiofile" variant="outline-primary">
                      <b-select-option v-for="(audiofile) in audiofilesDb" :key="audiofile.audiofile_id" :value="audiofile.audiofile_id">{{audiofile.filename}}</b-select-option>
                    </b-select>
                  </div>
                  <p class="text-success" v-if="isSaveSuccessful">Campagne succesvol opslagen!</p>
                  <b-button variant="primary" class="btn-fw" v-on:click="createCampaign()">Opslaan</b-button>
                  </div>
                </form>
              </b-tab>
              <b-tab title="Contacten">
                <form style="margin: 20px;" action="#">
                  <div>
                    <div class="d-flex justify-content-center">
                      <h4  v-if="contactsDb.length > 0" class="h4" style="margin-bottom:40px">Geïmporteerde contacten</h4>
                    </div>
                    <div>
                      <div class="d-flex justify-content-center">
<!--                        <h4 style="margin-bottom:50px" class="h6">Er werden nog geen contacten geïmporteerd voor deze campagne</h4>-->
                        <b-table v-if="contactsDb.length > 0" striped hover :busy="isBusy" :items="contactsDb" :fields="contactFields" style="max-width:65%; margin-bottom:50px;">
                          <template #table-busy>
                            <div class="text-center text-success my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Contacten aan het importeren...</strong>
                            </div>
                          </template>
                          <template v-slot:cell(contact_id)="{ value }">
                            <b-button variant="danger" class="icon-btn" @click="deleteContact(value)">
                              <i class="mdi mdi-delete"></i>
                            </b-button>
                          </template>
                        </b-table>
                      </div>
                      <div>
                        <div v-if="contactsDb.length > 0" class="d-flex justify-content-center">
                          <b-button variant="danger" @click="deleteAllContactsFromCampaign()">Verwijder alle contacten</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <h5 v-if="contactsDb.length === 0 || contactsDb === false" class="h4" style="margin-bottom:40px">Importeer contacten</h5>
                    <h5 v-else class="h4" style="margin-top:40px">Importeer meer contacten</h5>
                  </div>
                  <div>
                    <div class="d-flex justify-content-center" style="margin-top:20px">
                      <span class="text-success text-center" id="successfulImports"></span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span style="margin-top:20px; margin-bottom:10px; text-align: center" class="text-danger text-center h6" id="unsuccessfulImports"></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="label">Kies een CSV of Excel bestand (met een .xlsx of xls extensie)</label>
                    <div class="input-group col-xs-6">
                      <input ref="csvuploadPlaceholder" type="text" class="form-control file-upload-info" disabled="" :placeholder="[[ csvfilename ]]">
                      <span class="input-group-append">
                        <input id="csvupload" ref="csvupload" @change="csvfilechange" class="file-upload-browse btn btn-primary" type="file" hidden/>
                      <button class="file-upload-browse btn btn-primary" @click="chooseCSVFile()" type="button">Kies bestand</button>
                    </span>
                    </div>
                  </div>
                  <p id="errorMessage" style="color: red; font-weight: bold"></p>
                  <b-button variant="primary" class="btn-fw" v-on:click="importContacts()">Importeer contacten</b-button>
                  <div style="margin-top:25px" v-if="isBusy === true" class="circle-loader"></div>
                </form>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <modal ref="campaignModal">
      <template v-slot:header>start_campaign
        <div class="d-flex justify-content-center">
          <h1 class="text-center">Start campagne</h1>
        </div>
      </template>
      <template v-slot:body>

      </template>
      <template v-slot:footer>
        <div>
          <div class="d-flex justify-content-center">
            <h5 class="card-5 text-center" style="margin-bottom:40px;">Stap 1: selecteer aanwezige collega's</h5>
          </div>
          <div class="d-flex justify-content-center">
            <b-table striped hover :items="items" :fields="fields" style="max-width:65%;">
              <template v-slot:cell(isActive)="row">
                <b-form-checkbox v-model="row.isActive" @change="colleagueActiveChanged($event)">
                </b-form-checkbox>
              </template>
            </b-table>
          </div>
          <div>
          </div>
        </div>
        <b-col class="text-right">
          <div>
            <b-button type="submit" value="submit" class="btn btn-danger" @click="$refs.usermodal.closeModal()">Annuleer</b-button>
<!--            <b-button class="btn btn-success" @click="createUser()">Opslaan</b-button>-->
          </div>
        </b-col>
      </template>
    </modal>
  </section>
</template>

<script>
import axios from 'axios'
import Modal from '../modals/Modal'
import statsLineGraph1 from '../../components/charts/dashboard_1/stats-line-graph-1'
import statsLineGraph2 from '../../components/charts/dashboard_1/stats-line-graph-2'
import store from '../../store'
let server = require('../../server')
export default {
  name: 'campaignDetail',
  components: {
    Modal,
    statsLineGraph1,
    statsLineGraph2
  },
  data () {
    return {
      campaign: null,
      contactsDb: [],
      statusContactsDb: [],
      imported_contacts: [],
      invalid_contacts: [],
      audiofilesDb: [],
      name: '',
      description: '',
      firstTabSelected: false,
      secondTabSelected: true,
      thirdTabSelected: false,
      contacts_called: 0,
      contacts_forwarded: 0,
      contacts_answering_machine: 0,
      isCampaignActive: false,
      isLoading: true,
      user_is_online: '',
      isBusy: false,
      isSaveSuccessful: false,
      resumePauseButtonText: 'INACTIEF',
      files: null,
      filesvoicemail: null,
      csvfiles: null,
      fileHasChanged: false,
      fileHasChangedvoicemail: false,
      filename: 'Kies een audiobestand',
      filenamevoicemail: 'Kies een audiobestand',
      csvfilename: 'Kies een CSV of Excel bestand',
      voicemails: [],
      selectedVoicemailFile: '',
      selectedRedirectAudiofile: '',
      audiofilesRedirect: [],
      campaignId: '',
      errors: [],
      fields: [
        {
          key: 'isActive',
          label: 'Is aanwezig?',
          thStyle: {width: '100px'}
        },
        {
          key: 'first_name',
          label: 'Collega'
        }
      ],
      contactFields: [
        {
          key: 'first_name',
          label: 'Voornaam'
        },
        {
          key: 'last_name',
          label: 'Naam'
        },
        {
          key: 'city',
          label: 'Stad'
        },
        {
          key: 'phone_number',
          label: 'Telefoonnummer'
        },
        {
          key: 'contact_id',
          label: 'Verwijder contact'
        }
      ],
      statusContactsFields: [
        {
          key: 'first_name',
          label: 'Voornaam'
        },
        {
          key: 'last_name',
          label: 'Achternaam'
        },
        {
          key: 'city',
          label: 'Stad'
        },
        {
          key: 'phone_number',
          label: 'Telefoonnummer'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'result',
          label: 'Resultaat'
        }
      ]
    }
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async mounted () {
    this.campaignId = this.$route.params.campaignId
    console.log(this.$route.params.campaignId)
    if (this.campaignId !== false) {
      this.isLoading = false
      console.log('this.campaignId = ')
      console.log(this.campaignId)
      this.campaignId = this.campaignId.toString()
      let self = this

      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_contacts_by_campaign_id/' + self.campaignId
        })
          .then(async function (response) {
            console.log('get_contacts_by_campaign_id data = ')
            console.log(response.data)
            self.contactsDb = response.data.contacts
            self.contacts_called = response.data.contacts_called
            self.contacts_forwarded = response.data.contacts_forwarded
            self.contacts_answering_machine = response.data.contacts_answering_machine
            self.statusContactsDb = response.data.contacts

            try {
              await axios({
                method: 'get',
                url: server.SERVER_URL + '/get_campaign_by_id/' + self.campaignId
              })
                .then(function (response) {
                  console.log('get_campaign_by_id data = ')
                  console.log(response.data)
                  self.campaign = response.data
                  self.name = response.data.name
                  self.description = response.data.description
                  self.filename = response.data.filename
                  self.selectedRedirectAudiofile = response.data.selectedRedirectAudiofile
                  self.selectedVoicemailFile = response.data.selectedVoicemailFile
                })
            } catch (e) {
              console.log('Error while trying to get contacts by campaign_id')
              console.log(e)
            }
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    } else {
      this.campaign = false
      this.isLoading = false
    }
    await this.getAllAudiofilesByOfficeId(this.office.toString())
  },
  methods: {
    async getAllAudiofilesByOfficeId (officeId) {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_all_audiofiles_by_office_id/' + officeId
        })
          .then(function (response) {
            console.log('Audiofiles =')
            console.log(response.data)
            self.audiofilesDb = response.data
          })
      } catch (e) {
        console.log('Error while trying to get audiofiles!!')
        console.log(e)
      }
    },
    updateCampaign () {
      console.log()
    },
    async deleteAllContactsFromCampaign () {
      console.log('Deleting all contacts for campaigh with id: ' + this.campaignId)
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/delete_all_contacts_by_campaignId/' + self.campaignId
        })
          .then(async function (response) {
            await self.refreshStatusContactsDb()
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    async deleteContact (contactId) {
      let i = this.contactsDb.map(item => item.contact_id).indexOf(contactId)
      this.contactsDb.splice(i, 1)
      this.$forceUpdate()
      console.log('Preparing to delete contact with id: ' + contactId)
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/delete_contact_by_contact_id/' + contactId
        })
          .then(async function (response) {
            // console.log('get_contacts_by_campaign_id data = ')
            await self.refreshStatusContactsDb()
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    async refreshStatusContactsDb () {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_contacts_by_campaign_id/' + self.campaignId
        })
          .then(async function (response) {
            // console.log('get_contacts_by_campaign_id data = ')
            console.log('refresh database')
            console.log(response.data)
            self.contactsDb = response.data.contacts
            self.statusContactsDb = response.data.contacts

            self.contacts_called = response.data.contacts_called
            self.contacts_forwarded = response.data.contacts_forwarded
            self.contacts_answering_machine = response.data.contacts_answering_machine
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    async getCampaignStatus () {
      let self = this
      let formData = new FormData()
      let user = self.user
      let data = user.data
      let email = data.email
      console.log('email = ')
      console.log(email)
      formData.append('email', email)
      try {
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/get_campaign_status/' + self.campaignId,
          data: formData
        })
          .then(async function (response) {
            self.isCampaignActive = response.data.is_active
            self.contacts_called = response.data.contacts_called
            self.contacts_forwarded = response.data.contacts_forwarded
            self.contacts_answering_machine = response.data.contacts_answering_machine
            self.user_is_online = response.data.user_is_online
            if (self.isCampaignActive === false) {
              self.resumePauseButtonText = 'INACTIEF'
            }
            if (self.user_is_online === 'no') {
              self.$root.$emit('user_is_offline', 'user_is_offline')
            }
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    colleagueActiveChanged (e) {
      if (e === true) {
        this.totalColleaguesAvailable += 1
        this.isStep2Visible = true
        this.startCallButtonVisible = true
      } else {
        this.totalColleaguesAvailable -= 1
        this.startCallButtonVisible = false
      }

      this.validCampaign = this.totalColleaguesAvailable > 0

      console.log("Total colleagues selected: '" + this.totalColleaguesAvailable.toString() + "'")
    },
    async resumePauseButtonClick (e) {
      let url = ''
      let self = this

      let error = document.getElementById('errorMessageCampaign')
      error.style.display = 'flex'
      error.innerText = ''
      self.resumePauseButtonText = 'INACTIEF'
      self.isCampaignActive = false
      if (!this.isCampaignActive) {
        console.log('Resuming campaign!')

        this.resumePauseButtonText = 'ACTIEF'
        this.isCampaignActive = true

        url = '/start_campaign/' + this.campaignId
        console.log('starting campaign with id: ' + this.campaignId.toString())
        let formData = new FormData()
        formData.append('totalColleaguesAvailable', this.totalColleaguesAvailable)
        let self = this
        try {
          await axios({
            method: 'post',
            url: server.SERVER_URL + url
          })
            .then(function (response) {
              console.log('response after starting_campaign = ')
              console.log(response)
              if (response.data.error === 'OTHER_CAMPAIGN_ACTIVE') {
                console.log('')
                let error = document.getElementById('errorMessageCampaign')
                error.style.display = 'flex'
                error.innerText = 'Er is al een andere campagne actief. Pauzeer de andere campagne om deze te kunnen starten.'
                self.resumePauseButtonText = 'INACTIEF'
                self.isCampaignActive = false
                return
              }
              if (response.data.error === 'NO_EMPLOYEES_ONLINE') {
                console.log('')
                let error = document.getElementById('errorMessageCampaign')
                error.style.display = 'flex'
                error.innerText = 'Er zijn geen medewerkers die klaar zijn om inkomende gesprekken te accepteren. Verander je status van offline naar online links in het zijmenu.'
                self.resumePauseButtonText = 'INACTIEF'
                self.isCampaignActive = false
                return
              }
              self.colleaguesModalDb = response.data
              self.resumePauseButtonText = 'ACTIEF'
              self.isCampaignActive = true

              if (self.isCampaignActive !== 'false' && self.isCampaignActive !== false) {
                // let x = window.setInterval(() => {
                let intervalId = window.setInterval(() => {
                  self.refreshStatusContactsDb()
                  self.getCampaignStatus()
                  console.log('self.isCampaignActive = ')
                  console.log(self.isCampaignActive)
                  if (self.isCampaignActive === false) {
                    self.resumePauseButtonText = 'INACTIEF'
                    self.isCampaignActive = false
                  }
                  try {
                    if (!self.isCampaignActive) {
                      window.clearInterval(intervalId)
                    }
                  } catch (e) {
                    console.error('Error while trying to stop renew interval...')
                  }


                }, 1000)
              } else {
                console.log('Stop fetching campaign status! Campaign is not active anymore!')
                self.resumePauseButtonText = 'INACTIEF'
                self.isCampaignActive = false
              }
            })
        } catch (e) {
          console.log('Error while trying to get users!')
          console.log(e)
        }
      } else {
        this.resumePauseButtonText = 'INACTIEF'
        this.isCampaignActive = false
        console.log('Pausing campaign!')
        url = '/pause_campaign/' + this.campaignId
      }

      try {
        await axios({
          method: 'post',
          url: server.SERVER_URL + url
        })
          .then(function (response) {
            self.colleaguesModalDb = response.data
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    getActiveInactiveClass () {
      return {
        'text-success': this.isCampaignActive,
        'text-danger': !this.isCampaignActive
      }
    },
    chooseFiles () {
      document.getElementById('fileupload').click()
    },
    chooseFilesvoicemail () {
      document.getElementById('fileuploadvoicemail').click()
    },
    chooseCSVFile () {
      document.getElementById('csvupload').click()
    },
    filechange (e) {
      this.files = this.$refs.file.files[0]
      this.filename = this.files.name
      this.fileHasChanged = true
    },
    filechangevoicemail (e) {
      this.filesvoicemail = this.$refs.file.files[0]
      this.filenamevoicemail = this.files.name
      this.fileHasChangedvoicemail = true
    },
    csvfilechange (e) {
      this.csvfile = this.$refs.csvupload.files[0]
      this.csvfilename = this.csvfile.name
    },
    async importContacts () {
      this.isBusy = true
      console.log('504 import contacts function!')
      let successfulImports = document.getElementById('successfulImports')
      let unsuccessfulImports = document.getElementById('unsuccessfulImports')
      successfulImports.innerText = ''
      unsuccessfulImports.innerText = ''
      let file = document.getElementById('csvupload').files[0]
      let campaignId = this.campaignId
      console.log('Importing contacts for campaign with id => ')
      console.log(campaignId)
      let formData = new FormData()
      formData.append('csvfile', file)
      let self = this

      let error = document.getElementById('errorMessage')
      error.style.display = 'flex'
      error.innerText = ''

      try {
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/upload_csv/' + campaignId,
          data: formData
        })
          .then(async function (response) {
            let data = response.data
            self.isBusy = false

            let isError = data.is_error
            console.log('isError = ' + isError.toString())
            let errorMessageRES = data.error_message
            console.log('error_message = ' + errorMessageRES.toString())
            if (isError === true) {
              if (errorMessageRES === 'INVALID HEADERS') {
                let error = document.getElementById('errorMessage')
                error.style.display = 'flex'
                error.innerText = 'Geen "Voornaam", "Naam" of "Telefoonnummer" kolom gevonden in het CSV bestand.'
                return false
              }

              if (errorMessageRES === 'No file' || data === false) {
                console.log('No file detected!')
                let error = document.getElementById('errorMessage')
                error.style.display = 'flex'
                error.innerText = 'Geen bestand geselecteerd.'
                return false
              }

              if (errorMessageRES === 'NOTCSV') {
                console.log('Please choose a CSV file. You tried processing a xxx file')
                let error = document.getElementById('errorMessage')
                error.style.display = 'flex'
                error.innerText = errorMessageRES
                return false
              }

              if (errorMessageRES !== 'NOTCSV' && errorMessageRES !== 'No file' && errorMessageRES !== 'INVALID HEADERS') {
                let error = document.getElementById('errorMessage')
                error.style.display = 'flex'
                error.innerText = 'Er heeft zich een onverwachtse fout voorgedaan.'
                return false
              }
            }

            self.contacts = data.contacts
            self.numberOfImportedContacts = data.imported_contacts
            self.numberOfInvalidContacts = data.invalid_contacts
            console.log('numberOfImportedContacts = ' + self.numberOfImportedContacts.toString())
            console.log('numberOfInvalidContacts = ' + self.numberOfInvalidContacts.toString())
            let successfulImports = document.getElementById('successfulImports')
            let unsuccessfulImports = document.getElementById('unsuccessfulImports')

            if (self.numberOfImportedContacts !== 0) {
              if (self.numberOfImportedContacts === 1) {
                successfulImports.innerText = '1 contact succesvol geïmporteerd.'
              } else {
                successfulImports.innerText = self.numberOfImportedContacts.toString() + ' contacten succesvol geïmporteerd.'
              }
            }
            if (self.numberOfInvalidContacts !== 0) {
              if (self.numberOfInvalidContacts === 1) {
                unsuccessfulImports.innerText = self.numberOfInvalidContacts.toString() + ' contact kon niet worden geïmporteerd. Mogelijke reden: ongeldig telefoonnummer of contact werd reeds geïmporteerd in deze campagne.'
              } else {
                unsuccessfulImports.innerText = self.numberOfInvalidContacts.toString() + ' contacten niet kunnen importeren. Mogelijke redenen: ongeldig telefoonnummer of contact werd reeds geïmporteerd in deze campagne.'
              }
            }
            self.startCallButtonVisible = true

            try {
              await axios({
                method: 'get',
                url: server.SERVER_URL + '/get_contacts_by_campaign_id/' + self.campaignId
              })
                .then(async function (response) {
                  // console.log('get_contacts_by_campaign_id data = ')
                  // console.log(response.data)
                  self.contactsDb = response.data.contacts
                  self.statusContactsDb = response.data.contacts

                  self.contacts_called = response.data.contacts_called
                  self.contacts_forwarded = response.data.contacts_forwarded
                  self.contacts_answering_machine = response.data.contacts_answering_machine
                })
            } catch (e) {
              console.log('Error while trying to get contacts by campaign_id')
              console.log(e)
            }

            console.log('Just set contacts!')
            self.$forceUpdate()
            console.log('refreshed table! ~~~')
            // self.fillTable(data)
            let button = document.getElementById('step2')
            button.style.display = 'flex'
            let table = document.getElementById('mytable')
            table.style.display = 'flex'
            console.log('step2 + flex is visislbe now...')
          })
        return this.contacts
      } catch (e) {
        return e
      }
    },
    async createCampaign () {
      this.errors = []
      let self = this
      this.isSaveSuccessful = false
      if ((this.name.length > 0) && (this.description.length > 0)) {
        try {
          let postData = new FormData()
          console.log('creating postData...')

          postData.append('name', this.name)
          postData.append('description', this.description)
          postData.append('user', JSON.stringify(this.user))
          postData.append('office', this.office)
          postData.append('selectedRedirectAudiofile', this.selectedRedirectAudiofile)
          postData.append('selectedVoicemailFile', this.selectedVoicemailFile)
          console.log('this.office = ' + this.office.toString())
          console.log('campaignId = ')
          console.log('checkign filehaschanged?')
          // if (!this.fileHasChanged) {
          //   postData.append('filePresent', false)
          // } else {
          //   postData.append('file', this.files)
          //   postData.append('filePresent', true)
          // }
          console.log(this.campaignId)
          let url = ''
          if (self.campaignId === false) {
            url = '/create_campaign'
          } else {
            url = '/update_campaign/' + self.campaignId
          }
          await axios({
            method: 'post',
            url: server.SERVER_URL + url,
            data: postData,
            headers: {
              'Content-Type': 'multipart/form-data',
              'Accept': 'application/json'
            }
          }).then(function (response) {
            self.isSaveSuccessful = true
            console.log('response after creating campaign = ')
            console.log(response.data)
            self.campaignId = response.data
          })
        } catch (e) {
          console.error('Error while trying to get users!')
          console.error(e)
        }
      } else {
        if (this.name.length === 0) {
          this.errors.push('Naam is verplicht')
        }
        if (this.description.length === 0) {
          this.errors.push('Beschrijving is verplicht')
        }
        if (this.selectedRedirectAudiofile === '') {
          this.errors.push('Selecteer een audiobestand.')
        }
        if (this.selectedVoicemailFile === '') {
          this.errors.push('Selecteer een voicemail audiobestand.')
        }
      }
    }
  }
}
</script>

<style scoped>
.tabs-component {
  margin: 4em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.static {
  position:fixed;
  bottom: 20px;
  right: 40%;
  left: 50%
}

.staticOnlineoffline {
  position:fixed;
  bottom: 20px;
  right: 80%;
  left: 20%
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    transform: translateY(2px);
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 4em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 4em 2em;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/basic-elements/campaignDetail.vue